import styled from 'styled-components';

export const Info = styled.section`
  display: flex;
  align-items: center;
  padding: 24px;
  width: 100%;
`;

export const DateTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: ${({ theme }) => theme.rulesList.name};
`;

export const OrderNo = styled.p`
  font-size: 12px;
`;

export const ReportDetailsTextGroup = styled.div``;

export const IconImg = styled.img`
  margin-right: 16px;
`;

export const IconImgDownload = styled.img`
  margin-left: auto;
`;

export const ReportTagContainer = styled.div`
  margin-left: auto;
`;
